
import { Badge } from "@/components/ui/badge";
import { FileText } from "lucide-react";

export function DraftIndicator() {
  return (
    <Badge variant="secondary" className="flex items-center gap-1 px-2 py-1">
      <FileText className="w-3 h-3" />
      Draft Saved
    </Badge>
  );
}
